import { render, staticRenderFns } from "./SearchOrders.vue?vue&type=template&id=74fd9f5c&"
import script from "./SearchOrders.vue?vue&type=script&lang=js&"
export * from "./SearchOrders.vue?vue&type=script&lang=js&"
import style0 from "./SearchOrders.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports